import { DireflowComponent } from "direflow-component";
import AppData from "./direflow-service";



/**
 * direflowProperties that comes Wxcc desktop layout
 */
const direflowProperties = {
  wxccStaticResourceUrl: '',
  agentId: '',
  agentName: '',
  agentDnis: '',
  agentAni: '',
  cadVariables: '',
  taskSelected: '',
  taskMap: '',
  taskMapInteraction: '',
  Id: '',
  Dnis: '',
  Ani: '',
  Cv: '',
  Ts: '',
  Tm: '',
  Tmi: ''
};

/**
 * DireflowComponent & its configurations.
 * 
 */
export default DireflowComponent.create({
  component: AppData,
  configuration: {
    tagname: "patient-assist",
    useShadow: true,
  },
  properties: direflowProperties,
  plugins: [
    {
      name: 'external-loader',
      options: {
        paths: [
          {
            src: `https://wxcc.pacdev.patient-assist.agenta-cloud.com/src.f69400ca.css`,
            async: true,
            useHead: true
          },
          {
            src: 'https://wxcc.pacdev.patient-assist.agenta-cloud.com/src.f69400ca.css',
            async: true
          }
        ],
      }
    }
  ]
}).then((compnent: any) => {
  // Do something with the component once it's mounted on the DOM.
  //console.log('LOADED......')
  //console.log('LOADED......', compnent);
  //compnent.style.fontSize = '10%'
});
